import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommLocationIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M12 6.75C9.65278 6.75 7.74999 8.65279 7.74999 11C7.74999 13.3472 9.65278 15.25 12 15.25C14.3472 15.25 16.25 13.3472 16.25 11C16.25 8.65279 14.3472 6.75 12 6.75ZM9.24999 11C9.24999 9.48122 10.4812 8.25 12 8.25C13.5188 8.25 14.75 9.48122 14.75 11C14.75 12.5188 13.5188 13.75 12 13.75C10.4812 13.75 9.24999 12.5188 9.24999 11Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M12.0011 1.25C8.17495 1.25 4.52462 3.51303 2.99671 7.08468C1.57475 10.4086 2.34454 13.2373 3.94729 15.6595C5.26134 17.6454 7.17792 19.4178 8.90699 21.0168C9.23666 21.3217 9.55967 21.6204 9.87023 21.9129L9.87188 21.9145C10.4469 22.4528 11.2107 22.75 12.0011 22.75C12.7915 22.75 13.5553 22.4528 14.1303 21.9145C14.4239 21.6396 14.7281 21.3592 15.0385 21.0732C16.7865 19.4628 18.73 17.672 20.0578 15.6609C21.6586 13.2362 22.4257 10.4045 21.0055 7.08468C19.4776 3.51303 15.8273 1.25 12.0011 1.25ZM4.37582 7.67465C5.65463 4.68528 8.74172 2.75 12.0011 2.75C15.2605 2.75 18.3476 4.68528 19.6264 7.67465C20.7984 10.4144 20.207 12.7124 18.806 14.8344C17.5885 16.6786 15.8049 18.3242 14.0517 19.9418C13.734 20.235 13.4173 20.5272 13.1051 20.8195C12.8128 21.0932 12.4173 21.25 12.0011 21.25C11.5853 21.25 11.19 21.0934 10.8977 20.8201C10.5653 20.5069 10.2276 20.1942 9.88897 19.8806C8.1581 18.2778 6.40281 16.6523 5.19823 14.8318C3.79586 12.7124 3.20227 10.4179 4.37582 7.67465Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
